import { BrowserCacheLocation } from '@azure/msal-browser';

export const environment = {
    production: true,
    edgeService: 'https://api.gbs-ls.ceres.siemens.cloud',
    // AppSync Events URLs
    appSyncRealtimeUrl: 'wss://appsync.api.gbs-ls.ceres.siemens.cloud/event/realtime',
    appSyncHttpUrl: 'https://appsync.api.gbs-ls.ceres.siemens.cloud/event',
    scdUrl: 'https://api.scd.suites.siemens.cloud',
    siteCollection: '/test/10000120',
    languageAssetsPath: './assets/language/',
    tracking: false,
    whitelist: ['api.gbs-ls.ceres.siemens.cloud'],
    apiKey: 'zHqbqgvjVp5gnyTTHtyaI2z9fGS1c4cN980LqTzc',
    tenant: 'GBS LS',
    guestAccess: false,
    links: {
        documentOfferTemplate: '',
        documentOfferTemplateEN: ''
    },
    junoApp: 'https://juno.suites.siemens.cloud',
    junoApiURI: 'https://api.mail.wcs-apps.siemens.cloud/v2.0',
    junoAppId: '73a1c4a89ae54505824b6f0f4fcc78b3',
    commentRequiredThreshold: 10,
    timeSheetSumRowFloatingPoints: '1.2-2',
    timeSheetRounding: false,
    servicesDocumentationLink:
        'https://siemens.sharepoint.com/teams/LogisticServices/Operational%20Excelence/Forms/AllItems.aspx?FolderCTID=0x012000260755B1EF128644AB157F93E2FBD47D&ovuser=38ae3bcd%2D9579%2D4fd4%2Dadda%2Db42e1495d55a%2Cvesely%2Ejosef%40siemens%2Ecom&OR=Teams%2DHL&CT=1731005539086&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI0OS8yNDEwMDMyNDkxNiIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D&id=%2Fteams%2FLogisticServices%2FOperational%20Excelence%2FProcess%20Improvement%2FCERES&viewid=c86fef5f%2D8a02%2D4a2c%2Da273%2D33126a0659f2',
    msalConfig: {
        auth: {
            clientId: 'b6801828-107c-455c-9352-73249bd6d37c', // Your application's client ID from Entra ID
            authority: 'https://login.microsoftonline.com/38ae3bcd-9579-4fd4-adda-b42e1495d55a', // Your tenant ID in format https://login.microsoftonline.com/${tenantId}
            redirectUri: window.location.origin, // Where to redirect after login, this needs to match exactly the redirectUri in Azure
            postLogoutRedirectUri: window.location.origin, // Where to redirect after logout
            navigateToLoginRequestUrl: true // Navigate back to the original request URL after login, this needs to match exactly the redirectUri in Azure
        },
        cache: {
            cacheLocation: BrowserCacheLocation.SessionStorage, // Store auth data in session storage
            storeAuthStateInCookie: false // Don't use cookies for state
        },
        system: {
            allowPlatformBroker: false // Don't use platform brokers like WAM
        }
    },
    apiConfig: [
        {
            scopes: ['User.ReadBasic.All', 'User.Read'],
            uri: 'https://graph.microsoft.com/v1.0'
        },
        {
            scopes: ['https://api.gbs-ls.ceres.siemens.cloud/App.Access.All'],
            uri: 'https://api.gbs-ls.ceres.siemens.cloud/'
        }
    ]
};
